import { render, staticRenderFns } from "./TextProperty.vue?vue&type=template&id=52592a62"
import script from "./TextProperty.vue?vue&type=script&lang=js"
export * from "./TextProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports